import { useCallback } from 'react';

import { useEventEmitter } from '../../utils/useEventEmitter';
import { useUtils } from '../../utils/useUtils';

export const useFab = (props, widgetName) => {
  const { className, children, onClick, name, 'aria-label': ariaLabel } = props;
  const { getConfig } = useUtils(props, widgetName);
  const { emitEvent } = useEventEmitter();

  const variant = getConfig('variant', 'circular');
  const color = getConfig('color', 'primary');
  const size = getConfig('size', 'small');
  const disabled = getConfig('disabled', false);
  const textUnderline = getConfig('textUnderline', false);

  const onButtonClick = useCallback(
    (e) => {
      emitEvent(e.type, { label: ariaLabel || undefined });

      if (typeof onClick === 'function') {
        onClick(e);
      }
    },
    [emitEvent, ariaLabel, onClick],
  );

  return { className, children, variant, color, disabled, textUnderline, size, name, onButtonClick };
};

export const useButton = (props, widgetName) => {
  const { emitEvent } = useEventEmitter();
  const { getConfig } = useUtils(props, widgetName);

  const { href, startIcon, className, children, disableRipple, ...rest } = props;

  delete rest.isRequired;

  const variant = getConfig(`variant`, `contained`);
  const color = getConfig(`color`, `primary`);
  const disableElevation = getConfig(`disableElevation`, true);
  const disabled = getConfig(`disabled`, false);
  const fullWidth = getConfig(`fullWidth`, false);
  const textUnderline = getConfig('textUnderline', true);
  const size = getConfig('size', 'medium');

  const shouldDisableRipple = disableRipple ?? variant === 'text';

  const onButtonClick = useCallback(
    (e) => {
      if (e.target.textContent) {
        emitEvent(e.type, { label: e.target.textContent });
      }

      if (typeof props.onClick === 'function') {
        props.onClick(e);
      }
    },
    [emitEvent, props.onClick],
  );

  return {
    className,
    children,
    variant,
    color,
    disabled,
    disableElevation,
    shouldDisableRipple,
    fullWidth,
    onButtonClick,
    textUnderline,
    href,
    size,
    startIcon,
    ...rest,
  };
};
